import { render, staticRenderFns } from "./links.vue?vue&type=template&id=1cff9de0"
import script from "./links.vue?vue&type=script&lang=js"
export * from "./links.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Img: require('/home/runner/work/platform/platform/packages/client/src/components/elements/base/image/Img.vue').default,Link: require('/home/runner/work/platform/platform/packages/client/src/components/elements/base/link/Link.vue').default,Placeholder: require('/home/runner/work/platform/platform/packages/client/src/components/elements/base/placeholder/Placeholder.vue').default,Loader: require('/home/runner/work/platform/platform/packages/client/src/components/utils/loader/Loader.vue').default,LinkTreeItem: require('/home/runner/work/platform/platform/packages/client/src/components/elements/link-tree/LinkTreeItem.vue').default,SocialLinks: require('/home/runner/work/platform/platform/packages/client/src/components/elements/social/SocialLinks.vue').default})
